import Scriba from 'react-scriba';

export class DataContratDeReservation {

    static _chargementContratsDeReservations = (filtres, tri, facteurNbreEnregistrement, pageIndex) => {
        let objet = {
            "tri": tri,
            "filtres": filtres,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };

        const url = "api/Liste/ListeDesContratsDeReservations";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementContratsDeReservationsPourCorriger = (filtres, tri, facteurNbreEnregistrement, pageIndex) => {
        let objet = {
            "tri": tri,
            "filtres": filtres,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };

        const url = "api/Liste/ListeDesContratsDeReservationsPourCorriger";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _signatureContratDeReservation(idReservation, idOperation, rowGUID) {
        const objet = { idReservation, idOperation, rowGUID };
        const url = "api/SignatureElectronique/SW_OrganizationSignature";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _corrigerSignatureElectroniqueParEI = (objet) => {
        const url = "api/SignatureElectronique/CorrigerSignatureElectroniqueParEI";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementSignatureElectroniqueInformation(objet) {
        const url = "api/SignatureElectronique/ChargementSignatureReservationInformationsEnBDD";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}
